import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "../../../../../Typography";
const BannerText = ({ children }) => _jsx(Typography, { variant: "caption-default", children: children });
export default BannerText;
